import { ExtensionNodeView } from '@atlaskit/editor-common/extensibility';
import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export function lazyExtensionNodeView(nodeName) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return ExtensionNodeView.apply(void 0, params);
  }
  return withLazyLoading({
    nodeName: nodeName,
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-extension-nodeview" */
      '@atlaskit/editor-common/extensibility').then(function (_ref) {
        var ExtensionNodeView = _ref.ExtensionNodeView;
        return ExtensionNodeView.apply(void 0, params);
      });
      return result;
    }
  });
}